<!-- ========== PAGE HERO ========== -->
<section class="ds-page-hero">
  <div class="ds-orb ds-orb--soft ds-page-hero__orb-1"></div>
  <div class="ds-orb ds-orb--cobalt ds-page-hero__orb-2"></div>
  <div class="container ds-page-hero__inner">
    <span class="ds-pill">Hakkımızda</span>
    <h1>E-ticaret dünyasını yenilikçi yapay zeka ile dönüştürüyoruz</h1>
    <p class="ds-lead">2021'den bu yana Türkiye'nin önde gelen e-ticaret platformlarına yapay zeka asistanları sağlıyoruz.</p>
  </div>
</section>

<section class="ds-section ds-about">
  <div class="container">
    <div class="row align-items-center g-5">
      <div class="col-lg-6">
        <span class="ds-pill">Misyonumuz</span>
        <h2>Müşteri deneyimini en üst seviyeye çıkarmak</h2>
        <p class="ds-lead mb-4">
          Keyo AI olarak, e-ticaret dünyasını dönüştüren yenilikçi yapay zeka çözümleri sunuyoruz.
        </p>
        <p class="mb-4">
          2021 yılında kurulan şirketimiz, Türkiye'nin önde gelen e-ticaret platformlarına hizmet vermektedir.
          Müşteri deneyimini en üst seviyeye çıkarmak için sesli ve yazılı yapay zeka asistanları geliştiriyoruz.
        </p>
        <div class="ds-about__stats">
          <div class="ds-about__stat">
            <h3>50+</h3>
            <p>Aktif Müşteri</p>
          </div>
          <div class="ds-about__stat">
            <h3>1M+</h3>
            <p>Aylık Etkileşim</p>
          </div>
          <div class="ds-about__stat">
            <h3>%99.9</h3>
            <p>Uptime</p>
          </div>
          <div class="ds-about__stat">
            <h3>%95+</h3>
            <p>Müşteri Memnuniyeti</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="ds-panel">
          <div class="ds-frame">
            <div class="ds-frame__chrome"><span></span><span></span><span></span></div>
            <div class="ds-frame__body">
              <img src="assets/images/about-illustration.svg" alt="About Keyo AI">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ========== FINAL CTA ========== -->
<section class="ds-final-cta">
  <div class="container">
    <div class="ds-final-cta__panel">
      <div class="ds-orb ds-orb--soft ds-final-cta__orb"></div>
      <div class="ds-final-cta__content">
        <h2>Bizimle Çalışmak İster misiniz?</h2>
        <p class="ds-lead">E-ticaret sitenize Keyo AI'yı entegre edelim ve müşteri deneyiminizi dönüştürelim.</p>
        <a routerLink="/contact" class="btn btn-light btn-lg mt-3">İletişime Geç</a>
      </div>
    </div>
  </div>
</section>
